const { REACT_APP_API_URL } = process.env;
const { REACT_APP_API_KEY } = process.env;

export { REACT_APP_API_URL, REACT_APP_API_KEY };
